import * as React from "react";
import type { SVGProps } from "react";
const SvgSportsRun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#sports-run_svg__a)">
      <path d="M14 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M11.2 15.61a.994.994 0 0 0-1.34.45l-.41.82-4.25-.85c-.54-.11-1.07.24-1.18.78s.24 1.07.78 1.18l5 1c.07.01.13.02.2.02a1 1 0 0 0 .89-.55l.75-1.5a.993.993 0 0 0-.45-1.34z" />
      <path d="m19.32 11.05-2.78-.93-2.83-2.83s-.1-.08-.15-.11c-.01 0-.02-.02-.04-.03-.1-.06-.21-.1-.32-.12-.02 0-.03-.01-.04-.02h-.04c-.1-.01-.21-.02-.32 0h-.04L7.8 8c-.47.09-.8.5-.8.98v3c0 .55.45 1 1 1s1-.45 1-1V9.8l2.78-.55-.76 4.57c-.06.37.09.74.39.96l3.6 2.7v3.5c0 .55.45 1 1 1s1-.45 1-1v-4c0-.31-.15-.61-.4-.8l-3.51-2.64.58-3.48 1.63 1.63q.165.165.39.24l3 1c.11.04.21.05.32.05.42 0 .81-.26.95-.68a1 1 0 0 0-.63-1.26z" />
    </g>
    <defs>
      <clipPath id="sports-run_svg__a">
        <path fill="currentColor" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSportsRun;
